const d3_10color = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"];
const color_brewer1 = ["#fbb4ae","#b3cde3", "#ccebc5","#decbe4","#fed9a6","#ffffcc","#e5d8bd","#fddaec"];
const color_brewer2 = ["#b3e2cd","#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"];
const COLORS = [
    "#1A7AB1",
    "#ADC8E6",
    "#FF772D",
    "#FFB87F",
    "#2AA13A",
    "#98E090",
    "#FF9398",
    "#9467B9",
    "#C5B0D3",
    "#C49B95",
    "#E474C0",
    "#F7B4D1",
    "#BCBC3D",
    "#07C1CD"
    ]

const color_collection = d3_10color.concat(color_brewer1).concat(color_brewer2).concat(COLORS);

const GREEN = [
    "#498B77",
    "#89C2AE",
    "#C1D6D3",
    "#20DF20"
]
const BLUE = [
    "#3E97C7",
    "#72B3CF",
    "#8FCCDD",
    "#C8DADE"

]
const ORANGE = [
    "#E96206",
    "#F79143",
    "#F6AD76",
    "#F7CEA7"
]
const PINK = [
    "#F6B1C3",
    "#F07F93",
    "#DE4863",
    "#BC0F46"

]
const RED = ["#DC143C", "#E64C4C"];
const YELLOW = ['#fee08b'];
const GRAY = ['#999999'];
const WHITE = ["#ffffff"];


const getCorrectnessColor = (correctness) => {
    if(correctness == false){
        return RED[1] // "#fb8072";
    }else{
        return "#93C47D" // GREEN[0] // "#93C47D";
    }
}
const getRelationColor = (index) => {
    let color_index = index % color_collection.length;
    if(color_index < 0) color_index = 0;
    if(color_index >= color_collection.length) color_index = color_collection.length - 1;
    return color_collection[color_index];
}
const getSaliencyColor = (attribution) => {
    let step = (attribution + 1 ) / 2;
    if(step <0){
        step = 0;
    }
    if(step>1){
        step = 1;
    }
    let ColorList = [RED[1], WHITE[0], "#93C47D"];
    return getLinearColor(ColorList, step);
}
const getLinearColor = (ColorList , step) => {
    let totalColor = ColorList.length;
    let divide = 1/ (totalColor - 1);
    let location = Math.floor(step / divide);
    if(location == totalColor - 1){
        location = location - 1;
    }
    let offset = step - location * divide;
    let adjusted_offset = offset / divide;
    return getGradientColor(ColorList[location], ColorList[location+1], adjusted_offset);
}
const getGradientColor = (startColor ,endColor ,step ) => {
    let colorRgb = (sColor)=>{
        var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
        sColor = sColor.toLowerCase();
        if(sColor && reg.test(sColor)){
            if(sColor.length === 4){
                var sColorNew = "#";
                for(var i=1; i<4; i+=1){
                    sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));
                }
                sColor = sColorNew;
            }
            var sColorChange = [];
            for(let i=1; i<7; i+=2){
                sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));
            }
            return sColorChange;
        }else{
            return sColor;
        }
    };
    startColor = startColor.replace(/\s+/g,"");
    endColor = endColor.replace(/\s+/g,"");
    let startRGB = colorRgb(startColor);//转换为rgb数组模式
    //console.log(startRGB);
    let startR = startRGB[0];
    let startG = startRGB[1];
    let startB = startRGB[2];

    let endRGB = colorRgb(endColor);
    //console.log(endRGB);

    let endR = endRGB[0];
    let endG = endRGB[1];
    let endB = endRGB[2];
    if(step>1){
        console.log("out of range step: ", step);
        step = 1;
    }else if(step<0){
        console.log("out of range step: ", step);
        step = 0;
    }
    let sR = (endR-startR)*step;//总差值
    let sG = (endG-startG)*step;
    let sB = (endB-startB)*step;
    var R = parseInt((sR+startR));
    var G = parseInt((sG+startG));
    var B = parseInt((sB+startB));
    var strHex = "#";
    var aColor = new Array();
    aColor[0] = R;
    aColor[1] = G;
    aColor[2] = B;
    for(let j=0; j<3; j++){
        let hex  = Number(aColor[j]).toString(16);
        let shex  = Number(aColor[j])<10 ? '0'+hex :hex;
        if(shex === "0"){
            shex += shex;
        }
        strHex += shex;
    }
    return strHex;
}

function hexToRgbA(hex, alpha){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+alpha+')';
    }
    console.log("Bad Hex", hex, alpha);
    return 'rgba(0,0,0,1)';
    //throw new Error('Bad Hex');
}

export { getSaliencyColor, getCorrectnessColor, getRelationColor}